/** Canonical public site origin for share links, invites, and Stripe return URLs. */

const DEFAULT_PUBLIC_SITE_URL = 'https://lockedin-h2h.com';

function normalizeOrigin(url) {
  return String(url || '').trim().replace(/\/$/, '');
}

/**
 * Production builds should set REACT_APP_PUBLIC_SITE_URL (e.g. https://lockedin-h2h.com).
 * Falls back to window.location.origin in the browser, then the default custom domain.
 */
export function getPublicSiteOrigin() {
  const configured = normalizeOrigin(process.env.REACT_APP_PUBLIC_SITE_URL);
  if (configured) return configured;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return normalizeOrigin(window.location.origin);
  }
  return DEFAULT_PUBLIC_SITE_URL;
}

export function buildPublicSiteUrl(path = '/') {
  const origin = getPublicSiteOrigin();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${normalizedPath}`;
}
